module.exports = __webpack_public_path__ + "img/img-follow-qrcode.e9454f0a.png";